/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Canvas_Open_Artifact_UnavailableInputs */



/**
* | output |
* | --- |
* | "Opening another item is only available inside oneAI, not on a shared link." |
*
* @param {Canvas_Open_Artifact_UnavailableInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const canvas_open_artifact_unavailable = /** @type {((inputs?: Canvas_Open_Artifact_UnavailableInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Canvas_Open_Artifact_UnavailableInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Ein anderes Element zu öffnen ist nur in oneAI möglich, nicht über einen geteilten Link.")
	return /** @type {LocalizedString} */ ("Opening another item is only available inside oneAI, not on a shared link.")
});